export const PROJECTS_DETAILED = [
  {
    anchorId: 'project-louis',
    nameKey: 'projectsDetailed.louis.name',
    categoryKey: 'projectsDetailed.categories.ai',
    problemKey: 'projectsDetailed.louis.problem',
    architectureKey: 'projectsDetailed.louis.architecture',
    stack: ['Node.js', 'MongoDB Atlas', 'ChromaDB', 'BGE-M3', 'OpenAI embeddings', 'SSE'],
    technicalChallenges: [
      'projectsDetailed.louis.challenges.0',
      'projectsDetailed.louis.challenges.1',
      'projectsDetailed.louis.challenges.2',
    ],
    outcomeKey: 'projectsDetailed.louis.outcome',
    visualsKey: 'projectsDetailed.louis.visuals',
    links: {
      repository: '',
      demo: '',
    },
    references: [
      {
        type: 'internal',
        to: '/ai-engineering#ai-louis',
        labelKey: 'projectsDetailed.references.aiPage',
      },
      {
        type: 'internal',
        to: '/experience#experience-harbor',
        labelKey: 'projectsDetailed.references.harborExp',
      },
    ],
  },
  {
    anchorId: 'project-harbor-blog',
    nameKey: 'projectsDetailed.harborBlog.name',
    categoryKey: 'projectsDetailed.categories.ai',
    problemKey: 'projectsDetailed.harborBlog.problem',
    architectureKey: 'projectsDetailed.harborBlog.architecture',
    stack: ['Node.js', 'ChromaDB', 'OpenAI embeddings', 'RAG pipeline'],
    technicalChallenges: [
      'projectsDetailed.harborBlog.challenges.0',
      'projectsDetailed.harborBlog.challenges.1',
      'projectsDetailed.harborBlog.challenges.2',
    ],
    outcomeKey: 'projectsDetailed.harborBlog.outcome',
    visualsKey: 'projectsDetailed.harborBlog.visuals',
    links: {
      repository: '',
      demo: '',
    },
    references: [
      {
        type: 'internal',
        to: '/experience#experience-harbor',
        labelKey: 'projectsDetailed.references.harborExp',
      },
      {
        type: 'internal',
        to: '/ai-engineering#ai-louis',
        labelKey: 'projectsDetailed.references.aiPage',
      },
    ],
  },
  {
    anchorId: 'project-svn-manager',
    nameKey: 'projectsDetailed.svnManager.name',
    categoryKey: 'projectsDetailed.categories.infrastructure',
    problemKey: 'projectsDetailed.svnManager.problem',
    architectureKey: 'projectsDetailed.svnManager.architecture',
    stack: ['SVN', 'Node.js', 'Automation', 'Internal tooling'],
    technicalChallenges: [
      'projectsDetailed.svnManager.challenges.0',
      'projectsDetailed.svnManager.challenges.1',
      'projectsDetailed.svnManager.challenges.2',
    ],
    outcomeKey: 'projectsDetailed.svnManager.outcome',
    visualsKey: 'projectsDetailed.svnManager.visuals',
    links: {
      repository: '',
      demo: '',
    },
    references: [
      {
        type: 'internal',
        to: '/experience#experience-cyframe',
        labelKey: 'projectsDetailed.references.cyframeExp',
      },
    ],
  },
  {
    anchorId: 'project-cyframe-rag',
    nameKey: 'projectsDetailed.cyframeRag.name',
    categoryKey: 'projectsDetailed.categories.ai',
    problemKey: 'projectsDetailed.cyframeRag.problem',
    architectureKey: 'projectsDetailed.cyframeRag.architecture',
    stack: ['Python', 'SentenceTransformers', 'ChromaDB', 'SVN ingestion', 'IIS + ASP'],
    technicalChallenges: [
      'projectsDetailed.cyframeRag.challenges.0',
      'projectsDetailed.cyframeRag.challenges.1',
    ],
    outcomeKey: 'projectsDetailed.cyframeRag.outcome',
    visualsKey: 'projectsDetailed.cyframeRag.visuals',
    links: {
      repository: '',
      demo: '',
    },
    references: [
      {
        type: 'internal',
        to: '/ai-engineering#ai-cyframe-rag',
        labelKey: 'projectsDetailed.references.aiPage',
      },
      {
        type: 'internal',
        to: '/experience#experience-cyframe',
        labelKey: 'projectsDetailed.references.cyframeExp',
      },
    ],
  },
  {
    anchorId: 'project-cyframe-dev',
    nameKey: 'projectsDetailed.cyframeDev.name',
    categoryKey: 'projectsDetailed.categories.ai',
    problemKey: 'projectsDetailed.cyframeDev.problem',
    architectureKey: 'projectsDetailed.cyframeDev.architecture',
    stack: ['Python', 'Vector DB', 'Internal docs'],
    technicalChallenges: [
      'projectsDetailed.cyframeDev.challenges.0',
      'projectsDetailed.cyframeDev.challenges.1',
    ],
    outcomeKey: 'projectsDetailed.cyframeDev.outcome',
    visualsKey: 'projectsDetailed.cyframeDev.visuals',
    links: {
      repository: '',
      demo: '',
    },
    references: [
      {
        type: 'internal',
        to: '/ai-engineering#ai-cyframe-dev',
        labelKey: 'projectsDetailed.references.aiPage',
      },
      {
        type: 'internal',
        to: '/experience#experience-cyframe',
        labelKey: 'projectsDetailed.references.cyframeExp',
      },
    ],
  },
  {
    anchorId: 'project-eval-harness',
    nameKey: 'projectsDetailed.evalHarness.name',
    categoryKey: 'projectsDetailed.categories.research',
    problemKey: 'projectsDetailed.evalHarness.problem',
    architectureKey: 'projectsDetailed.evalHarness.architecture',
    stack: ['Python', 'RAG eval', 'BM25', 'Hybrid', 'Rerank'],
    technicalChallenges: [
      'projectsDetailed.evalHarness.challenges.0',
      'projectsDetailed.evalHarness.challenges.1',
    ],
    outcomeKey: 'projectsDetailed.evalHarness.outcome',
    visualsKey: 'projectsDetailed.evalHarness.visuals',
    links: {
      repository: '',
      demo: '',
    },
    references: [
      {
        type: 'internal',
        to: '/ai-engineering#ai-eval-harness',
        labelKey: 'projectsDetailed.references.aiPage',
      },
      {
        type: 'internal',
        to: '/experience#experience-cyframe',
        labelKey: 'projectsDetailed.references.cyframeExp',
      },
    ],
  },
  {
    anchorId: 'project-athack',
    nameKey: 'projectsDetailed.athack.name',
    categoryKey: 'projectsDetailed.categories.cyber',
    problemKey: 'projectsDetailed.athack.problem',
    architectureKey: 'projectsDetailed.athack.architecture',
    stack: ['CTF Ops', 'Web', 'Crypto', 'Forensics', 'Binary'],
    technicalChallenges: [
      'projectsDetailed.athack.challenges.0',
      'projectsDetailed.athack.challenges.1',
      'projectsDetailed.athack.challenges.2',
    ],
    outcomeKey: 'projectsDetailed.athack.outcome',
    visualsKey: 'projectsDetailed.athack.visuals',
    links: {
      repository: 'https://github.com/EchoingEkko00/AtHack2025',
      demo: 'https://athackctf.com/',
    },
    references: [
      {
        type: 'internal',
        to: '/cybersecurity#cyber-case-studies',
        labelKey: 'projectsDetailed.references.cyberPage',
      },
    ],
  },
  {
    anchorId: 'project-mcgill',
    nameKey: 'projectsDetailed.mcgill.name',
    categoryKey: 'projectsDetailed.categories.fullStack',
    problemKey: 'projectsDetailed.mcgill.problem',
    architectureKey: 'projectsDetailed.mcgill.architecture',
    stack: ['React', 'p5.js', 'Physics simulation', 'Data viz'],
    technicalChallenges: [
      'projectsDetailed.mcgill.challenges.0',
      'projectsDetailed.mcgill.challenges.1',
    ],
    outcomeKey: 'projectsDetailed.mcgill.outcome',
    visualsKey: 'projectsDetailed.mcgill.visuals',
    links: {
      repository: 'https://github.com/EchoingEkko00/hackaton-mcgill-physics-2023',
      demo: 'https://echoingekko00.github.io/mcgill-physics-hackathon-2023/',
    },
  },
  {
    anchorId: 'project-flow',
    nameKey: 'projectsDetailed.flow.name',
    categoryKey: 'projectsDetailed.categories.fullStack',
    problemKey: 'projectsDetailed.flow.problem',
    architectureKey: 'projectsDetailed.flow.architecture',
    stack: ['React', 'Spring Boot', 'JWT', 'MySQL'],
    technicalChallenges: [
      'projectsDetailed.flow.challenges.0',
      'projectsDetailed.flow.challenges.1',
    ],
    outcomeKey: 'projectsDetailed.flow.outcome',
    visualsKey: 'projectsDetailed.flow.visuals',
    links: {
      repository: 'https://github.com/echoingekko00/applicationTache',
      demo: '',
    },
  },
  {
    anchorId: 'project-portfolio',
    nameKey: 'projectsDetailed.portfolio.name',
    categoryKey: 'projectsDetailed.categories.fullStack',
    problemKey: 'projectsDetailed.portfolio.problem',
    architectureKey: 'projectsDetailed.portfolio.architecture',
    stack: ['Vue 3', 'Vue Router', 'Tailwind CSS', 'Node/Express'],
    technicalChallenges: [
      'projectsDetailed.portfolio.challenges.0',
      'projectsDetailed.portfolio.challenges.1',
      'projectsDetailed.portfolio.challenges.2',
    ],
    outcomeKey: 'projectsDetailed.portfolio.outcome',
    visualsKey: 'projectsDetailed.portfolio.visuals',
    links: {
      repository: 'https://github.com/echoingekko00/portefolioVUEJS',
      demo: 'https://chrisdev.ca/',
    },
  },
  {
    anchorId: 'project-vocal',
    nameKey: 'projectsDetailed.vocal.name',
    categoryKey: 'projectsDetailed.categories.fullStack',
    problemKey: 'projectsDetailed.vocal.problem',
    architectureKey: 'projectsDetailed.vocal.architecture',
    stack: ['Kotlin', 'Sockets', 'Audio streaming'],
    technicalChallenges: [
      'projectsDetailed.vocal.challenges.0',
      'projectsDetailed.vocal.challenges.1',
    ],
    outcomeKey: 'projectsDetailed.vocal.outcome',
    visualsKey: 'projectsDetailed.vocal.visuals',
    links: {
      repository: 'https://github.com/echoingekko00/projet3Veille',
      demo: '',
    },
  },
];
